export class TrainingModel {
  id: string;
  type: string;
  level: TRAINING_LEVEL;
  job_title: string;
  start_of_apprenticeship: string;
  school_start_date: string;
  application_period: string;
  selection_period: string;
  success_rate: string;
  success_rate_year: string;
  file: string;
  img: any;
  address: string;
  postal_code: string;
  city: string;
  phone_number: string;
  email: string;
  id_organization: string;
  social_reason: string;
  visibility: string;
  createdAt: any;

  public mapToModel(data): TrainingModel {
    const trainingModel = new TrainingModel();
    trainingModel.id = data.id;
    trainingModel.type = data.type;
    trainingModel.level = data.level;
    trainingModel.job_title = data.job_title;
    trainingModel.img = data.img;
    trainingModel.start_of_apprenticeship = data.start_of_apprenticeship;
    trainingModel.school_start_date = data.school_start_date;
    trainingModel.application_period = data.application_period;
    trainingModel.selection_period = data.selection_period;
    trainingModel.success_rate = data.success_rate;
    trainingModel.success_rate_year = data.success_rate_year;
    trainingModel.file = data.file;
    trainingModel.address = data.organization.address;
    trainingModel.postal_code = data.organization.postal_code;
    trainingModel.city = data.organization.city;
    trainingModel.phone_number = data.organization.phone_number;
    trainingModel.email = data.organization.email;
    trainingModel.id_organization = data.organizationId;
    trainingModel.createdAt = data.organization.createdAt;
    trainingModel.visibility = data.visibility;

    return trainingModel;
  }

  public mapToSchema(data): TrainingModel {
    const trainingModel = new TrainingModel();

    trainingModel.id = data.id;
    trainingModel.job_title = data.job_title;
    trainingModel.start_of_apprenticeship = data.start_of_apprenticeship;
    trainingModel.school_start_date = data.school_start_date;
    trainingModel.application_period = data.application_period;
    trainingModel.selection_period = data.selection_period;
    trainingModel.success_rate = data.success_rate;
    trainingModel.success_rate_year = data.success_rate_year;
    trainingModel.img = data.img;
    trainingModel.file = data.file;

    return trainingModel;
  }
}
enum TRAINING_TYPE {
  HEALTH_AND_REHABILITATION = 'HEALTH_AND_REHABILITATION',
  MEDICO_TECHNICAL = 'MEDICO_TECHNICAL',
}

enum TRAINING_LEVEL {
  LEVEL_3 = 'LEVEL_3',
  LEVEL_4 = 'LEVEL_4',
  LEVEL_5 = 'LEVEL_5',
  LEVEL_6 = 'LEVEL_6',
  LEVEL_7 = 'LEVEL_7',
  LEVEL_8 = 'LEVEL_8',
}
